'use strict';

var selectors = {
  navItems: document.querySelectorAll('.js-customer-nav'),
  modules: document.querySelectorAll('.js-customer-module'),
  toggle: document.querySelector('.js-active-sidebar'),
  menu: document.querySelector('.Customer__sidebar')
};

function sidebar() {
  var navItems = selectors.navItems;

  var _loop = function _loop(item) {
    var view = item.dataset.target;
    item.addEventListener('click', function () {
      toggleView(view);
    });
    item.addEventListener('keydown', function (event) {
      return event.keyCode === 13 ? toggleView(view) : false;
    });
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {

    for (var _iterator = navItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      _loop(item);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  checkForLocation();
  mobileMenu();
}

function toggleView(view) {
  var modules = selectors.modules,
      navItems = selectors.navItems;

  var mobileTitle = document.querySelector('.js-sidebar-title');

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = navItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (item.dataset.target === view) {
        var text = item.querySelector('p').innerText;

        item.classList.add('active');
        mobileTitle.innerText = text;
      } else {
        item.classList.remove('active');
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = modules[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var module = _step3.value;

      if (module.dataset.module === view) {
        module.classList.remove('hide');
      } else {
        module.classList.add('hide');
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  if (selectors.toggle.classList.contains('open')) {
    toggleStates();
  }
}

function checkForLocation() {
  var urlHash = window.location.hash.replace('#', '');
  if (urlHash) {
    toggleView(urlHash);
  }
}

function toggleStates() {
  selectors.toggle.classList.toggle('open');
  selectors.menu.classList.toggle('open');
}

function mobileMenu() {
  selectors.toggle.addEventListener('click', function () {
    toggleStates();
  });
  selectors.toggle.addEventListener('keydown', function (event) {
    return event.keyCode === 13 ? toggleStates() : false;
  });
}

sidebar();